import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";

import { googleAds } from "appConfig";

import { getModuleContext } from "../../../HOCs";
import {
  selectSubLevel,
  getSubLevelCount,
  updateSubLevelSearch,
  selectSubLevelSearch,
  deleteSubLevelSearch,
  selectMakeDatasource,
  selectSubLevelParentCount,
  selectSubLevelName,
  selectNewAds,
  selectSubLevelTree
} from "../../../routes/Ad/ad.ducks";
import history from "../../../history";
import { PageRoute, QueryParam } from "../../../models";
import {
  stringifyURI,
  isMobileScreen,
  getWindowWidth
} from "../../../services/utils";
import SubLevel2Desktop from "./SubLevel2Desktop";
import SubLevel2Mobile from "./SubLevel2Mobile";
import {
  selectCurrentCategories,
  selectCurrentModuleName
} from "../../App/selectors";
import BreadcrumbBar from "../../../components/BreadcrumbBar";
import styles from "../styles/subLevel.scss";
import { mapCategoryToEn } from "../../../routes/LanguageMapper";
import GoogleAdInterstitial from "../../../components/GoogleAdInterstitial";
import { buildNodeRoutePath, findNode } from "../../../routes/Configuration/helpers";

function SubLevel2(props: any) {
  const {
    match: {
      params: { category }
    },
    module,
    level,
    isMakePage,
    levelParentCount
  } = props;
  const [routeLinks, setRouteLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listKey, setListKey] = useState(0);
  const [categoryLv1Id, setCategoryLv1Id] = useState(null);
  // lv1 nodes (with children) of the current category - set by getSubLevelCount
  const subLevelTree = useSelector(selectSubLevelTree);

  // the level1 url segment is the route of the lv1 node (legacy links carry the id)
  const resolveLevel1Id = (level1: string) => {
    const node = findNode(subLevelTree, level1);
    return node ? node.id : level1;
  };

  useEffect(() => {
    const {
      ads,
      level,
      module,
      categories,
      moduleName,
      subLevelName,
      match: {
        params: { category, level1 }
      }
    } = props;
    setLoading(true);
    props.getSubLevelCount(module, category, 1, level1, () => {
      setLoading(false);
    });


    if (props.level.length !== 0) {
      const level1Id = resolveLevel1Id(level1);

      setCategoryLv1Id(level1Id);
      props.updateSubLevelSearch([level1Id]);
    }

    if (categories.length > 0) {
      const categoryName = categories.find(
        cate => cate.name === mapCategoryToEn(category, module)
      ).displayName;

      setRouteLinks([
        { title: moduleName, link: `/${module}` },
        { title: categoryName, link: `/${module}/${category}` },
        { title: subLevelName }
      ]);
    }
  }, [level.length !== 0]);

  const handleBoxClick = ({ id }) => {
    const {
      match: {
        params: { level1 }
      }
    } = props;

    handleSellectAll();
    props.updateSubLevelSearch([resolveLevel1Id(level1), id]);
  };

  const handleAddMore = () => {
    const {
      match: {
        params: { category }
      },
      module
    } = props;

    history.push(`/${module}${PageRoute.search}${stringifyURI({ category }, QueryParam.searchQuery, true)}`);
  };

  const handleSearchClick = () => {
    const {
      match: {
        params: { category }
      },
      module,
      subLevelSearch
    } = props;


    if(subLevelSearch.categoryLv1Ids || subLevelSearch.categoryLv2Ids ) {
      const routePath = buildNodeRoutePath(
        subLevelTree,
        subLevelSearch.categoryLv1Ids ? subLevelSearch.categoryLv1Ids[0] : subLevelSearch.categoryLv2Ids[0]
      );
      const multiLevelRoute = routePath ? `/${routePath}` : "";

      history.push(
        `/${module}${category ? `/${category}` : ""}${
          multiLevelRoute ? multiLevelRoute : ""
        }${PageRoute.search}${stringifyURI({
          category,
          module,
          ...subLevelSearch
        }, QueryParam.searchQuery)}`
      );
    }
  };

  const handleSellectAll = () => {
    const {
      match: {
        params: { level1 }
      }
    } = props;

    props.deleteSubLevelSearch(resolveLevel1Id(level1));
    setListKey(prev => prev + 1);
  };

  const isMobile = isMobileScreen(getWindowWidth());

  return (
    <React.Fragment>
      {isMobile && (
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
      )}

      <BreadcrumbBar
        className={styles.breadcrumb}
        routeLinks={routeLinks}
        category={category}
      />
      {isMobile ? (
        <SubLevel2Mobile
          level={level}
          category={category}
          categoryLv1Ids={categoryLv1Id ? categoryLv1Id : undefined}
          module={module}
          loading={loading}
          onSellectAll={handleSellectAll}
          onBoxClick={handleBoxClick}
          onSearchClick={handleSearchClick}
          listKey={listKey}
          levelCount={levelParentCount}
        />
      ) : (
        <SubLevel2Desktop
          level={level}
          category={category}
          categoryLv1Ids={categoryLv1Id ? categoryLv1Id : undefined}
          module={module}
          loading={loading}
          onSellectAll={handleSellectAll}
          onBoxClick={handleBoxClick}
          onSearchClick={handleSearchClick}
          listKey={listKey}
          levelCount={levelParentCount}
          isMakePage={isMakePage}
        />
      )}
    </React.Fragment>
  );
}

SubLevel2.defaultProps = {
  level: [],
  levelParentCount: 0,
  ads: {}
};

export default getModuleContext(
  connect(
    (state: any) => ({
      level: selectSubLevel(state),
      subLevelSearch: selectSubLevelSearch(state),
      categories: selectCurrentCategories(state),
      isMakePage: selectMakeDatasource(state),
      levelParentCount: selectSubLevelParentCount(state),
      moduleName: selectCurrentModuleName(state),
      subLevelName: selectSubLevelName(state),
      ads: selectNewAds(state)
    }),
    {
      getSubLevelCount,
      updateSubLevelSearch,
      deleteSubLevelSearch
    }
  )(SubLevel2)
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel2/index.tsx